import styles from "./IntegratedCTA.module.scss";
import {
  SecondaryButton,
  UnderlinedButton,
} from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import SaleTag from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/SaleTag24PxFilledRed";
import { useTradeInContext } from "../../TradeInContext";
import { dispatchCustomEvent } from "../../../../utils/customEvent/dispatchCustomEvent";
import { TradeInEvents } from "../../TradeIn";

type Props = {
  isTradeInModelLoading: boolean;
  onClick: () => void;
};

export const IntegratedCTAUI = ({ isTradeInModelLoading, onClick }: Props) => {
  const { promotionValue, hasPromoCode } = useTradeInContext();
  const dispatchTradeInReadMoreEvent = () => {
    dispatchCustomEvent(TradeInEvents.TRADE_IN_READ_MORE_EVENT);
  };

  return (
    <div className={styles.cta} data-testid="integrated-cta">
      <h2 className={styles.cta__title}>
        Got a device you are no longer using?
      </h2>
      <p className={styles.cta__description}>
        Trade-in now and get some money back when making your new purchase
      </p>
      <SecondaryButton onClick={onClick} submitting={isTradeInModelLoading}>
        Trade in device
      </SecondaryButton>
      {!!promotionValue && (
        <div className={styles.cta__promo}>
          <p className={styles.cta__promoMessage}>
            <SaleTag />
            {hasPromoCode ? (
              <span>Receive an extra {promotionValue} off with promo code</span>
            ) : (
              <span>Get an extra {promotionValue} when you trade-in</span>
            )}
          </p>
          <UnderlinedButton
            tag="a"
            role="button"
            onClick={() => {
              dispatchTradeInReadMoreEvent();
            }}
          >
            Read more
          </UnderlinedButton>
        </div>
      )}
    </div>
  );
};
